module.exports = __webpack_public_path__ + "static/media/icon_reja.718e2318.svg";